export const APPLICANT_PROFILE_WIDGET_KEY = {
  attention: 'attention',
  matchedListing: 'matched-listing',
  stageScreening: 'stage-screening',
}

export const APPLICANT_PROFILE_WIDGET_LIST_ORDER = [
  APPLICANT_PROFILE_WIDGET_KEY.attention,
  APPLICANT_PROFILE_WIDGET_KEY.stageScreening,
  APPLICANT_PROFILE_WIDGET_KEY.matchedListing,
]
